import { OrderListResponseType } from "@sellar-io/api-v2/types";
import { InfiniteData, QueryCache } from "@tanstack/react-query";
import { ServerStateKeys } from "~/hooks/api/v2/ServerStateKeys";

const isInfiniteOrderListResponse = (
  data: unknown,
): data is InfiniteData<OrderListResponseType> =>
  typeof data === "object" &&
  data !== null &&
  "pages" in data &&
  Array.isArray(data.pages);

export const getNextOrderIdInList = ({
  orderId,
  uid,
  businessId,
  queryCache,
}: {
  orderId: number;
  uid: string | undefined;
  businessId: number | undefined;
  queryCache: QueryCache;
}) => {
  // get orders list from cache
  const query = queryCache.findAll({
    queryKey: [uid, businessId, ServerStateKeys.Orders],
  });

  for (const orderQuery of query) {
    const data = orderQuery.state.data;

    if (!isInfiniteOrderListResponse(data)) continue;

    // flatten all pages
    const flattenedOrdersArray = data.pages.flatMap(
      (array: OrderListResponseType) => array,
    );

    // get index of current order
    const currentItemIndex = flattenedOrdersArray.findIndex(
      (order: OrderListResponseType[number]) => order.id === orderId,
    );

    if (currentItemIndex === -1) continue;

    // get both next and previous orderIds
    // they will be used to redirect to the next/prev item in the list
    // when current order is accepted
    const nextOrderId = flattenedOrdersArray[currentItemIndex + 1]?.id;
    const prevOrderId = flattenedOrdersArray[currentItemIndex - 1]?.id;
    return nextOrderId ?? prevOrderId;
  }
};
